// extracted by mini-css-extract-plugin
export var contactWrapper = "contact-module--contactWrapper--2ovnd";
export var contactText = "contact-module--contactText--1VcAe";
export var contactForm = "contact-module--contactForm--3pdCx";
export var validateError = "contact-module--validateError--2y_KT";
export var response = "contact-module--response--BQPWk";
export var contactus = "contact-module--contactus--3qslF";